import apiService from "@/utils/request";

export const enumServe = {
  allEnum() {
    return apiService.get("/dg_admin/v2/dict/all_enum/");
  },
};
